
import formState  from "./states/form";
import aluno from './states/aluno';
import {tableState, detalhamento} from "@/store/modules/sie-pedidos/states/table";
import tableLotes from "@/store/modules/sie-pedidos/states/tableLotes";
import dadosFormSolicitacao from "@/store/modules/sie-pedidos/states/dadosFormSolicitacao";

const state = () => ({form: {...formState}, aluno, table: {...tableState}, detalhamento, tableLotes: {...tableLotes}, dadosForm: dadosFormSolicitacao })

export default state
